// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1AlVw","inputDescription":"styles_inputDescription__2_IhK"};